import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_express_page_list = _resolveComponent("express-page-list")!

  return (_openBlock(), _createBlock(_component_express_page_list, {
    list: _ctx.list,
    menuTab: _ctx.menuTab,
    addPower: "OrderManagement_Pool_Summary_DestinationPortExpress_Add",
    editPower: "OrderManagement_Pool_Summary_DestinationPortExpress_Edit",
    deletePower: "OrderManagement_Pool_Summary_DestinationPortExpress_Delete",
    serviceType: _ctx.serviceType,
    poolId: _ctx.$route.params.id
  }, null, 8, ["list", "menuTab", "serviceType", "poolId"]))
}